import type { RouteObject } from 'react-router';
import { AdminDashboardPage } from '../pages/admin-dashboard-page';

export const adminDashboardRoutes: RouteObject[] = [
  { index: true, element: <AdminDashboardPage /> },
];
